import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useUserMeStore, useWaitingStateStore } from '../../../store';
import { BookedChecklist } from './booked-appointment/BookedChecklist';
import { useWindowSize } from '../../../hooks';
import { WaitingState } from './waiting-phase/WaitingState';
import { UserStatus } from '@prisma/client';
import useRedirect from '../../../hooks/useRedirect';
import { OnboardingChecklistWrapper } from './onboarding-checklist/OnboardingChecklistWrapper';
import { Loading } from '../../../component';
import { HomeScreenWrapper } from './home-screen/HomeScreenWrapper';
import { NoData } from './deactivated';
import { ErrorCode } from '@web/common';
import { useMyCohortStore } from '../../../store/MyCohortStore';

export const Dashboard = observer(() => {
  const isSmallScreen = useWindowSize(600);
  const userMeStore = useUserMeStore();
  const waitingStateStore = useWaitingStateStore();
  const myCohortStore = useMyCohortStore();
  useRedirect();

  useEffect(() => {
    userMeStore.loadMyLatestAppointment();
    myCohortStore.loadMyCohort();
  }, [userMeStore, waitingStateStore, myCohortStore]);

  useEffect(() => {
    if (userMeStore.myInfo?.status === UserStatus.ACTIVE) {
      waitingStateStore.loadDataAndCheckAccess();
    }
  }, [waitingStateStore, userMeStore.myInfo?.status]);

  if (waitingStateStore.canAccessStudy) return <HomeScreenWrapper />;
  if (userMeStore.myInfo?.status === UserStatus.ACTIVE) return <WaitingState />;

  // when rendering components conditionally, don't put hooks inside them, but pass them
  const userInformation = userMeStore.appointment ? (
    <BookedChecklist isSmallScreen={isSmallScreen} />
  ) : (
    <OnboardingChecklistWrapper />
  );

  if (userMeStore.myInfo) return userInformation;
  else if (userMeStore.loadingInfo) return <Loading />;

  return <NoData errorCode={ErrorCode.CannotLoadDashboard} />;
});
